<div class="odontograma-detalle">
  <mat-tab-group>
    <mat-tab label="Odontograma">
      <app-odontograma-chart [estado]="estado" [mode]="'readonly'" [denticion]="denticion"></app-odontograma-chart>
      <div class="leyenda">
        <span class="item" *ngFor="let c of leyenda()">
          <span class="swatch" [style.background]="c.color"></span>{{ c.label }}
        </span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
